import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";
import OpeningHours from "shared/components/OpeningHours";
import Popover from "shared/components/Popover";
import Space from "shared/components/Space";
import { NAME_SPACES } from "shared/locals/constants";
import { formatOpeninHours } from "utils/helpers/hours";
import { useInfo } from "utils/hooks/info";
import "./styles.scss";

const Component = () => {
  const {
    info,
    info: { phone },
  } = useInfo();
  const { t } = useTranslation(NAME_SPACES.HOME, {
    keyPrefix: "PLANING_ERROR",
  });
  const openingHours = useMemo(
    () => formatOpeninHours(info.openHours),
    [info.openHours],
  );

  return (
    <div className={"rendezvous-error"}>
      <p className={"titlePlanningError"}>{t("TITLE")}</p>
      <Space h={20} />

      <p className={"description"}>{t("DESCRIPTION")}</p>
      <p className={"contact"}>{t("NUMBER", { phone })}</p>

      <Popover content={<OpeningHours data={openingHours} />}>
        <p className={"info"}>{t("OPENING_HOURS")}</p>
      </Popover>
    </div>
  );
};

Component.propTypes = {};

export default Component;
